import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const placeAnxiety: BlogMetaData = {
  title: '場所見知りはいつから？知らない場所で固まる時の対応をモンテッソーリ視点で解説',
  description:
    '場所見知りはいつから始まり、いつまで続く？旅行先や児童館・保育園で固まる原因と対応法を、モンテッソーリの秩序の敏感期の視点からやさしく解説。人見知りとの違いや相談先も紹介します。',
  thumbnailUrl: '/img/blog-place-anxiety.webp',
  filePath: buildBlogFilePath('place-anxiety'),
  category: BLOG_CATEGORY.PARENTING,
};
